var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsaapIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.404,
    height: 38.405,
    viewBox: "0 0 38.404 38.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9679",
    "data-name": "Group 9679",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M5279.255,3203.024a9.151,9.151,0,0,0-9.122,8.214,8.412,8.412,0,0,0-.046.883,9.009,9.009,0,0,0,1.745,5.335l-1.142,3.38,3.521-1.123a9.176,9.176,0,0,0,14.212-7.592c0-.24-.011-.475-.031-.709A9.151,9.151,0,0,0,5279.255,3203.024Zm5.349,12.849a2.663,2.663,0,0,1-1.8,1.261c-.49.046-.49.4-3.21-.659a10.98,10.98,0,0,1-4.566-4.007,6.078,6.078,0,0,1-.954-1.837,3.445,3.445,0,0,1-.138-.9,2.972,2.972,0,0,1,.934-2.215.99.99,0,0,1,.716-.331c.179,0,.357.026.511.026s.382-.092.6.438.76,1.838.827,1.97a.479.479,0,0,1,.021.465,3.352,3.352,0,0,1-.169.316c-.031.041-.06.082-.1.128-.138.154-.28.342-.4.464s-.271.276-.118.542a7.9,7.9,0,0,0,1.486,1.832,7.23,7.23,0,0,0,2.149,1.318c.269.133.423.112.582-.067s.67-.771.847-1.036.358-.225.6-.132,1.556.729,1.827.862.443.2.51.306A2.193,2.193,0,0,1,5284.6,3215.873Z",
    transform: "translate(-5259.798 -3194.026)",
    fill: "#f77f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M5264.108,3181a19.2,19.2,0,1,0,19.2,19.2A19.2,19.2,0,0,0,5264.108,3181Zm.253,28.917a10.906,10.906,0,0,1-5.267-1.348l-6.041,1.919,1.965-5.8a10.731,10.731,0,0,1-1.562-5.59c0-.159,0-.317.01-.474a10.907,10.907,0,0,1,21.794.2c0,.091,0,.183,0,.275A10.862,10.862,0,0,1,5264.361,3209.918Z",
    transform: "translate(-5244.905 -3181)",
    fill: "#f77f00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsaapIcon1);
export default __webpack_public_path__ + "static/media/whatsaap-icon1.75965b228c41cacef1d9e013fd1b6eb7.svg";
export { ForwardRef as ReactComponent };